import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  "data-month": "",
  class: "bg-white rounded-2xl border border-gray-200 p-5"
}
const _hoisted_2 = { class: "flex items-center justify-between gap-3" }
const _hoisted_3 = { class: "text-base font-extrabold text-gray-900" }
const _hoisted_4 = { class: "flex flex-wrap gap-x-5 gap-y-1 mt-2 text-xs text-gray-500" }
const _hoisted_5 = { class: "text-sm font-bold text-gray-900" }
const _hoisted_6 = { class: "text-sm font-bold text-gray-900" }
const _hoisted_7 = { class: "text-sm font-bold text-gray-900" }
const _hoisted_8 = { class: "text-sm font-bold text-gray-900" }
const _hoisted_9 = {
  key: 1,
  class: "mt-3 border-t border-gray-100 divide-y divide-gray-100"
}
const _hoisted_10 = { class: "text-xs rounded-full px-2 py-0.5 bg-gray-100 text-gray-700" }
const _hoisted_11 = { class: "flex-1 font-semibold text-gray-900 truncate" }

import { computed, ref } from 'vue'

import { cardState, formatReturn, laneLabel, money, PILL } from './marketingSeries'


export default {
  __name: 'MarketingMonthCard',
  props: {
  plan: { type: Object, required: true },
  collapsed: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const open = ref(false)
const hidden = computed(() => props.collapsed && !open.value)
const summary = computed(() => props.plan.attributes?.summary || {})
const inProgress = computed(() => props.plan.attributes?.status === 'ready')
const title = computed(() => {
  const [y, m] = (props.plan.attributes?.period_start || '').slice(0, 7).split('-').map(Number)
  if (!y) return ''
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  })
})

const resultOf = item => {
  const attrs = item.attributes || {}
  if (attrs.status === 'skipped') return { text: attrs.skip_reason ? `"${attrs.skip_reason}"` : 'Skipped', muted: true }
  if (!attrs.sms_eligible && !attrs.discount_code) return { text: 'not measured', muted: true }
  if (['proposed', 'needs_edit'].includes(attrs.status)) return { text: 'waiting on you', muted: true }
  return { text: `${attrs.orders_count || 0} orders · ${money(attrs.revenue_cents)}`, muted: false }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["text-xs font-bold rounded-full px-2.5 py-1", inProgress.value ? _unref(PILL).indigo : _unref(PILL).gray])
      }, _toDisplayString(inProgress.value ? 'In progress' : 'Closed'), 3)
    ]),
    _createElementVNode("dl", _hoisted_4, [
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createTextVNode(" Revenue ", -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(money)(summary.value.revenue_cents)), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createTextVNode(" Orders ", -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(summary.value.orders || 0), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createTextVNode(" Return ", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatReturn)(summary.value.return_multiple)), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createTextVNode(" Plays ", -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(summary.value.done_count || 0) + " of " + _toDisplayString(summary.value.total_count || 0) + " done ", 1)
      ])
    ]),
    (hidden.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          "data-toggle": "",
          class: "text-xs underline text-gray-600 mt-3",
          onClick: _cache[0] || (_cache[0] = $event => (open.value = true))
        }, " Show plays "))
      : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.items, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              "data-play": "",
              class: "flex items-center gap-3 py-2 text-sm"
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(laneLabel)(item.attributes.lane)), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.play?.attributes?.title || item.attributes.play_title), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs font-bold rounded-full px-2 py-0.5", _unref(cardState)(item).pill.classes])
              }, _toDisplayString(_unref(cardState)(item).pill.label), 3),
              _createElementVNode("span", {
                class: _normalizeClass(["w-40 text-right text-xs", resultOf(item).muted ? 'text-gray-400' : 'font-semibold text-gray-900'])
              }, _toDisplayString(resultOf(item).text), 3)
            ]))
          }), 128))
        ]))
  ]))
}
}

}